import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Refer } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Refer';
const referTypeEnum = ["grid", "tree", "gridTree"];
const displayTypeEnum = ["popover", "dropDown"];
/**
 * @class NCRefer
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCRefer
 * @label 参照
 *
 */
class NCRefer extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 标题
         * @description 标题
         */
        refName: PropTypes.string,
        /**
         * @title 参照类型
         * @description 参照类型
         * @enumNames ["grid", "tree","gridTree"]
         */
        refType: PropTypes.oneOf(referTypeEnum),
        /**
         * @title 参照类型
         * @description 参照类型
         * @enumNames ["popover", "dropDown"]
         */
        type: PropTypes.oneOf(displayTypeEnum),
        /**
         * @title 历史记录条数
         * @description 历史记录条数
         */
        hotDataSize: PropTypes.number,
        /**
        * @title 分页请求数据时每页条数
        * @description 分页请求数据时每页条数
        */
        pageSize: PropTypes.number,
        /**
        * @title 禁用
        * @description 禁用
        */
        disabled: PropTypes.bool,
        /**
       * @title 分页请求数据时每页条数
       * @description 分页请求数据时每页条数
       */
        pageSize: PropTypes.number,
        /**
        * @title 参照最外层的class
        * @description 参照最外层的class
        */
        referClassName: PropTypes.string,
        /**
       * @title 占位文字
       * @description 占位文字
       */
        placeholder: PropTypes.string,
        /**
        * @title 获取焦点时，是否显示历史记录
        * @description 获取焦点时，是否显示历史记录
        */
        showHistory: PropTypes.bool,
        /**
       * @title 查询表数据的请求url
       * @description 查询表数据的请求url
       */
        queryGridUrl: PropTypes.string,
        /**
        * @title 查询树数据的请求url
        * @description 查询树数据的请求url
        */
        queryTreeUrl: PropTypes.string,
        /**
        * @title 是否启用数据缓存
        * @description 是否启用数据缓存
        */
        isCacheable: PropTypes.bool,
        /**
       * @title 是否多选
       * @description 是否多选
       */
        isMultiSelectedEnabled: PropTypes.bool,
        /**
        * @title 缓存条数
        * @description 缓存条数
        */
        maxCacheNum: PropTypes.number,
        /**
       * @title 自动获取焦点
       * @description 自动获取焦点
       */
        autoFocus: PropTypes.bool,
        /**
        * @title 是否只有叶子节点可选
        * @description 是否只有叶子节点可选
        */
        onlyLeafCanSelect: PropTypes.bool,
        /**
       * @title 是否显示搜索设置
       * @description 是否显示搜索设置
       */
        allowSearchConfig: PropTypes.bool,
        /**
        * @title 是否显示列设置
        * @description 是否显示列设置
        */
        allowColumnConfig: PropTypes.bool,
        /**
       * @title 作为display的字段
       * @description 作为display的字段
       */
        fieldDisplayed: PropTypes.string,
        /**
        * @title 作为value的字段
        * @description 作为value的字段
        */
        fieldValued: PropTypes.string,
        /**
       * @title 是否显示停用数据
       * @description 是否显示停用数据
       */
        isShowDisabledData: PropTypes.bool,
        /**
       * @title 是否有【显示停用】功能
       * @description 是否有【显示停用】功能
       */
        isHasDisabledData: PropTypes.bool,
        /**
      * @title 是否显示停用数据
      * @description 是否显示停用数据
      */
        isShowDisabledData: PropTypes.bool,
        /**
       * @title 是否显示业务单元
       * @description 是否显示业务单元
       */
        isShowUnit: PropTypes.bool,
        /**
         * @title 严格的检查每一条数据
         * @description 严格的检查每一条数据
         */
        checkStrictly: PropTypes.bool,
        /**
          * @title 添加到弹出层的class
          * @description 添加到弹出层的class
          */
        popWindowClassName: PropTypes.string,
        /**
         * @title 树id对应的key值
         * @description 树id对应的key值
         */
        idKey: PropTypes.string,
        /**
         * @title 树pid对应的key值
         * @description 树pid对应的key值
         */
        pidKey: PropTypes.string,
        /**
        * @title 表格行对应的key值
        * @description 表格行对应的key值
        */
        rowKey: PropTypes.string,
        /**
         * @title 树表参照是否显示【常用】
         * @description 树表参照是否显示【常用】
         */
        isShowUsual: PropTypes.bool,
        /**
        * @title 显示表格区的搜索框
        * @description 显示表格区的搜索框
        */
        isShowTableSearch: PropTypes.bool,
        /**
         * @title 显示树区的搜索框
         * @description 显示树区的搜索框
         */
        isShowTreeSearch: PropTypes.bool,
        /**
         * @title 鼠标悬停时是否显示title
         * @description 鼠标悬停时是否显示title
         */
        showTitle: PropTypes.bool,
        /**
        * @title 是否启用【执行时包含下级】功能
        * @description 是否启用【执行时包含下级】功能
        */
        isRunWithChildren: PropTypes.bool,
        /**
         * @title 是否始终触发onChange事件
         * @description 是否始终触发onChange事件
         */
        isAlwaysEmitOnChange: PropTypes.bool,
        /**
        * @title 参照的tabindex
        * @description 参照的tabindex
        */
        tabIndex: PropTypes.number,
        /**
         * @title 只有选业务单元才会发请求
         * @description 只有选业务单元才会发请求
         */
        unitValueIsNeeded: PropTypes.bool,
        /**
        * @title tabIndex基于此值往上加
        * @description tabIndex基于此值往上加
        */
        baseTabIndex: PropTypes.number,
        /**
         * @title 关闭后是否需要获取焦点
         * @description 关闭后是否需要获取焦点
         */
        needFocusOnClose: PropTypes.bool,
        /**
        * @title dropdown组件的placement属性
        * @description dropdown组件的placement属性
        */
        dropDownPlacement: PropTypes.string,
        /**
        * @title 最多选择的数据条数
        * @description 最多选择的数据条数
        */
        maxChoice: PropTypes.number,
        /**
         * @title 请求是否异步
         * @description 请求是否异步
         */
        async: PropTypes.bool,

    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        refType: "grid",
        type: 'popover',
        hotDataSize: 10,
        pageSize: 10,
        disabled: false,
        showHistory: true,
        isCacheable: true,
        isMultiSelectedEnabled: false,
        maxCacheNum: 10,
        autoFocus: false,
        onlyLeafCanSelect: false,
        allowSearchConfig: false,
        allowColumnConfig: true,
        fieldDisplayed: 'refname',
        fieldValued: 'refpk',
        isShowDisabledData: true,
        isHasDisabledData: true,
        isShowUnit: true,
        checkStrictly: false,
        idKey: 'refpk',
        pidKey: 'pid',
        rowKey: 'refpk',
        isShowUsual: false,
        isShowTableSearch: true,
        isShowTreeSearch: true,
        showTitle: true,
        isRunWithChildren: false,
        isAlwaysEmitOnChange: false,
        unitValueIsNeeded: false,
        tabIndex: 0,
        baseTabIndex: 0,
        needFocusOnClose: true,
        dropDownPlacement: 'bottomLeft',
        maxChoice: 1000,
        async: true
    }
    render() {
        return (
            <Refer {...this.props} />
        )
    }
}

export default NCRefer;
